// storage 帮助类
import Storage from "utils/store";

//  扩展功能
export const extFunc = {
  name: "extFunc",
  state: {},
  reducers: {
    // 获取localStorage 里面的配置信息
    getSett(state, data: any) {
      const _data = Storage.l_get(data.uuid);
      let storageInfo: any;
      if (_data) {
        for (let item in _data) {
          if (item === data.name) {
            storageInfo = _data[item];
            break;
          }
        }
      }

      let settInfo = {};
      settInfo[data.name] = storageInfo;

      return { ...state, ...settInfo };
    },
    // 保存设置信息到LocalStorage中
    saveSett(state, data: any) {
      let _data = Storage.l_get(data.uuid);
      if (!_data) {
        _data = {};
      }
      _data[data.name] = data.settInfo;

      Storage.l_set(data.uuid, _data);
      return { ...state, ..._data };
    }
  }
};
